(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('RuoloSearch', RuoloSearch);

    RuoloSearch.$inject = ['$resource'];

    function RuoloSearch($resource) {
        var resourceUrl =  'api/_search/ruolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
